// eslint-disable-next-line import/named
import { Action, AnyAction, configureStore, ThunkAction, ThunkDispatch } from '@reduxjs/toolkit'
// reducers
import { authReducer as auth } from 'features/auth/authSlice'
import { batchReducer as batch } from 'features/autocheck/autoCheckSlice'
import { callsReducer as calls } from 'features/calls/callsSlice'
import { claimsReducer as claims } from 'features/claims/claimsSlice'
import { fileShareReducer as fileShare } from 'features/fileshare/FileShareSlice'
import { userReducer as user } from 'features/userManagement/userSlice'

import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux'

export const store = configureStore({
  reducer: {
    auth,
    claims,
    calls,
    batch,
    fileShare,
    user,
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware({ serializableCheck: false }),
})

export type AppDispatch = typeof store.dispatch
export type RootState = ReturnType<typeof store.getState>
export type AppThunk<ReturnType = void> = ThunkAction<ReturnType, RootState, unknown, Action<string>>

// Use throughout your app instead of plain `useDispatch` and `useSelector`
export type AppThunkDispatch = ThunkDispatch<RootState, void, AnyAction>

export const useAppDispatch = (): AppThunkDispatch => useDispatch<AppDispatch>()
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector
